import { Accordion, AccordionDetails, AccordionSummary, 
  Typography, Table, TableBody, TableCell, TableHead, TableRow, 
  useMediaQuery} from "@mui/material";
import Grid from '@mui/material/Grid2'
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import { PaperTooltipCustom } from "../Theme/ContainerStyle";


export const AccordionWrapper = ({children, title, defaultExpanded=false}) => {

  return (
    <Accordion defaultExpanded={defaultExpanded} className="site-map">
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography>{title}</Typography>
      </AccordionSummary>
      <AccordionDetails>
        {children}
      </AccordionDetails>
    </Accordion>
  )
}

export const TooltipChartWrapper = (props) => {
  const {tooltip,columns,titleTooltip,renderItem, plugin, widthTooltip} = props
  const sizeMedia = useMediaQuery('(min-width:800px)');
  plugin()
  return (
    ////RITORNA LA TABELLA TOOLTIP DEI GRAFICI
    <PaperTooltipCustom 
          elevation={3} //definisce l'ombra del tooltip
          tooltip= {tooltip}>
      <Table stickyHeader aria-label="sticky table">
        <TableHead>
          <TableRow>
            <TableCell align="center" style={{ padding: '1px', whiteSpace: 'pre-line'}}>
              <Typography fontWeight= 'bold' fontSize={sizeMedia ? "14px" : "12px"}>
                {titleTooltip}
              </Typography>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>
              <Grid container spacing={2}>
                {columns.map((column, index) => (
                  <Grid key={index} item style={{width: widthTooltip ? widthTooltip : 250}}>
                    <Table>
                      <TableBody>
                        {column.map(renderItem)}
                      </TableBody>
                    </Table>
                  </Grid>
                ))}
              </Grid>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </PaperTooltipCustom>
  );
}
